// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import ChannelState from "./types/channelState";
import { jsonBigIntMember } from "./types/bigint";
import { MessageType, MessageTypeName } from "./messageTypes";
import ProposalID from "./types/poposalID";
import Address from "./types/address";

@jsonObject
export default class OpenChannel extends PerunMessage {
  @jsonMember(ProposalID) proposalID: ProposalID;
  @jsonMember(Address) peerAddressEth: Address;
  @jsonMember(String) peerAddressCC: string;
  @jsonBigIntMember() challengeDuration: bigint;
  @jsonMember(ChannelState) state: ChannelState;

  constructor(
    proposalID: ProposalID,
    peerAddressEth: Address,
    peerAddressCC: string,
    challengeDuration: bigint,
    state: ChannelState,
  ) {
    super();
    this.proposalID = proposalID;
    this.peerAddressEth = peerAddressEth;
    this.peerAddressCC = peerAddressCC;
    this.challengeDuration = challengeDuration;
    this.state = state;
  }

  messageType(): MessageType {
    return OpenChannel;
  }

  messageTypeName(): MessageTypeName {
    return "OpenChannel";
  }
}
